export default [
    {
        path: ':category',
        name: 'kenesh.index',
        component: () => import('@/views/kenesh/Index.vue'),
    }
];